import type { ReactNode } from "react";
import { VLabel } from "@/components/ui/vLabel";
import { Caption } from "@/components/ui/typography";
import { cn } from "@/components/ui/cn";

type VFieldProps = {
  label?: string;
  htmlFor?: string;
  required?: boolean;
  optional?: boolean;
  hint?: string;
  error?: string;
  className?: string;
  children: ReactNode;
};

export function VField({
  label,
  htmlFor,
  required,
  optional,
  hint,
  error,
  className,
  children,
}: VFieldProps): React.JSX.Element {
  return (
    <div className={cn("flex flex-col gap-1.5", className)}>
      {label ? (
        <VLabel htmlFor={htmlFor} required={required} optional={optional}>
          {label}
        </VLabel>
      ) : null}
      {children}
      {hint && !error ? <Caption tone="muted">{hint}</Caption> : null}
      {error ? <Caption tone="error">{error}</Caption> : null}
    </div>
  );
}
